import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control';
import CreateModal from './create_modal';
import DealField from 'bundles/apex/deals/form/fields/field';
import EditModal from './edit_modal';
import { hasLeaseTerms } from 'bundles/apex/deals/lease_terms/helpers';

export function LeaseStructure({ deal, modalEditing }) {
  const [showCreateModal, setShowCreateModal] = useState();
  const [showEditModal, setShowEditModal] = useState();

  let modalControl;
  if (hasLeaseTerms(deal)) {
    if (modalEditing) {
      modalControl = (
        <a className="clickable" name="editControl" onClick={() => setShowEditModal(true)}>
          <FontAwesomeIcon className="me-2" icon={faPencilAlt} />
          Edit Rent Schedule
        </a>
      );
    }
  } else {
    modalControl = (
      <AddControl onClick={() => setShowCreateModal(true)}>
        <span aria-label="add-rent-schedule">Add Rent Schedule</span>
      </AddControl>
    );
  }

  function onCreate() {
    setShowCreateModal(false);

    if (modalEditing) {
      setShowEditModal(true);
    }
  }

  return <>
    <div className="my-2">
      {modalControl}
    </div>

    <CreateModal
      show={showCreateModal}
      onCancel={() => setShowCreateModal(false)}
      onCreate={onCreate}
    />

    <EditModal
      show={showEditModal}
      onClose={() => setShowEditModal(false)}
    />
  </>;
}

LeaseStructure.propTypes = {
  deal: PropTypes.shape({
    leaseStructure: PropTypes.object,
  }).isRequired,
  modalEditing: PropTypes.bool,
};

export default DealField(LeaseStructure, 'leaseStructure');
